import { FeatureToggle, useUnleashFlags } from '../../utils/useUnleashFlags';

export const useIsBetaMenuItem = (menuItemName: string): boolean => {
  const {
    b2bBetaMenuItemManagementAnalysis,
    b2bBetaMenuItemRateManagement,
    b2bBetaMenuItemCustomers,
    b2bBetaMenuItemCockpit,
    b2bBetaMenuItemHome,
  } = useUnleashFlags(
    FeatureToggle.BetaMenuItemManagementAnalysis,
    FeatureToggle.BetaMenuItemRateManagement,
    FeatureToggle.BetaMenuItemCustomers,
    FeatureToggle.BetaMenuItemCockpit,
    FeatureToggle.BetaMenuItemHome
  );

  const betaItemsList = {
    ManagementAnalysis: b2bBetaMenuItemManagementAnalysis,
    RateManagement: b2bBetaMenuItemRateManagement,
    Customers: b2bBetaMenuItemCustomers,
    Cockpit: b2bBetaMenuItemCockpit,
    Home: b2bBetaMenuItemHome,
  };

  return betaItemsList[menuItemName] ?? false;
};
